import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'outlierFilter',
    standalone: false
})
export class OutlierFilterPipe implements PipeTransform {

    transform(
        arr: any[], enableOutlier: boolean, obiousOutlier: boolean, zoom: boolean
    ): any {
        let resp = arr;
        if (arr && arr.length) {

            resp = resp.filter(
                element => {
                    if ((obiousOutlier && !element.manualOutlier) || enableOutlier ||
                        (!obiousOutlier && !enableOutlier && !element.outlier && !element.manualOutlier)) {
                        return element;
                    }
                }
            );
            return resp;
        }
    }
}
